var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import Button from '../Button';
import Scroll from '../Scroll';
import PositionWrapper from './PositionWrapper';
import { ComponentThemeProvider } from '../ThemeProvider';
import scrollupTheme from './theme';
import getIcon from '../utils/getIcon';
var ArrowUp = getIcon('ArrowMiniUp');
var StyledArrowUp = styled(ArrowUp)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: 5px;\n  font-size: 10px;\n"], ["\n  margin-left: 5px;\n  font-size: 10px;\n"])));
var StyledButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: auto;\n  pointer-events: auto;\n"], ["\n  width: auto;\n  pointer-events: auto;\n"])));
var VisibilityContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  visibility: ", ";\n"], ["\n  visibility: ", ";\n"])), function (props) { return (props.hidden ? 'hidden' : 'visible'); });
var Scrollup = /** @class */ (function (_super) {
    __extends(Scrollup, _super);
    function Scrollup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hidden: true,
        };
        _this.previousY = 0;
        _this.staticHideTimeout = 0;
        _this.hasBeenMounted = false;
        /**
         * Determines if Scrollup Component should be visible or hidden
         *
         * Bug: This method could trigger a chromium bug. When scrolling up sometimes the pageYOffset will be incresed
         * instead of decreased. For more information see: https://bugs.chromium.org/p/chromium/issues/detail?id=873870
         */
        _this.determineHiddenState = function () {
            var currentY = window.pageYOffset;
            var requiredDistanceFromTop = window.innerHeight * _this.props.scrollFactor;
            if (currentY < _this.previousY && currentY > requiredDistanceFromTop) {
                _this.setHidden(false);
                _this.setNewTimeout();
            }
            else if (currentY !== _this.previousY) {
                _this.setHidden(true);
            }
            _this.previousY = currentY;
        };
        /**
         * Clears old timeout and sets a new one
         */
        _this.setNewTimeout = function () {
            window.clearTimeout(_this.staticHideTimeout);
            _this.staticHideTimeout = window.setTimeout(function () { return _this.setHidden(true); }, _this.props.hideTimeout);
        };
        _this.setHidden = function (newHiddenState) {
            if (!_this.hasBeenMounted) {
                return;
            }
            _this.setState(function (previousState) {
                if (previousState.hidden === newHiddenState) {
                    return;
                }
                return {
                    hidden: newHiddenState,
                };
            });
        };
        _this.renderButton = function (scrollToTop) { return (React.createElement(StyledButton, { onClick: scrollToTop, layout: "primary" },
            React.createElement(FormattedMessage, { defaultMessage: "Upwards", id: "scrollup.button.text" }),
            React.createElement(StyledArrowUp, null))); };
        return _this;
    }
    Scrollup.prototype.componentDidMount = function () {
        this.hasBeenMounted = true;
        window.addEventListener('scroll', this.determineHiddenState);
    };
    Scrollup.prototype.componentWillUnmount = function () {
        this.hasBeenMounted = false;
        window.removeEventListener('scroll', this.determineHiddenState);
    };
    Scrollup.prototype.render = function () {
        var _a = this.props, buttonAlign = _a.buttonAlign, duration = _a.duration, maxWidth = _a.maxWidth, top = _a.top, className = _a.className;
        return (React.createElement(ComponentThemeProvider, { theme: scrollupTheme },
            React.createElement(VisibilityContainer, { className: className, hidden: this.state.hidden },
                React.createElement(PositionWrapper, { buttonAlign: buttonAlign, maxWidth: maxWidth, top: top },
                    React.createElement(Scroll, { duration: duration, positionAfterScroll: 0, render: this.renderButton })))));
    };
    Scrollup.defaultProps = {
        hideTimeout: 4000,
        scrollFactor: 1.5,
    };
    return Scrollup;
}(Component));
export { Scrollup };
export default Scrollup;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map